<section class="main-background">
  <section class="section1">
    <h2>Hola, soy</h2>
    <h1>Cristian Covarrubias</h1>
    <p>Un full Stack en desarrollo web con más de 9 años de experiencia</p>
  </section>
  <section class="section2">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/background%2Fyo.jpg?alt=media&token=e071cd36-3cf3-4ec7-b3cd-1f41f5927282"
      alt="imagen de cristian covarrubias"
    />
  </section>
</section>
